import { render, staticRenderFns } from "./productVersionName.vue?vue&type=template&id=7e401479"
import script from "./productVersionName.vue?vue&type=script&lang=js"
export * from "./productVersionName.vue?vue&type=script&lang=js"
import style0 from "./productVersionName.vue?vue&type=style&index=0&id=7e401479&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports